import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PageContainer from "../Layout/PageContainer";
import storageItemService from "../../redux/services/storageItem.service";

import StorageItemForm from "./StorageItemForm";
toast.configure();

const StorageType = (props) => {
  const navigate = useNavigate();

  const { id } = useParams();

  const [storageItemDetail, setStorageItemDetail] = useState({});

  useEffect(() => {
    if (!/\d+/.test(id)) {
      navigate("/storageItem/add");
    }
  }, [id, navigate]);

  useEffect(() => {
    if (props.currentUser.roleId === 2) {
      navigate("/dashboard");
    }
  }, [props.currentUser, navigate]);

  const getStorageType = (id) => {
    storageItemService
      .get(id)
      .then((response) => {
        console.log(response);
        setStorageItemDetail ( response.data.storageItemInfo );
      })
      .catch((error) => {
        toast(error, {
          transition: Slide,

          closeButton: true,

          autoClose: 3000,

          position: "top-right",

          type: "error",
        });
      });
  };

  useEffect(() => {
    if (id != "" && /\d+/.test(id)) getStorageType(id);
  }, [id]);

  return (
    <PageContainer
      pageTitleIcon="pe-7s-tools icon-gradient bg-plum-plate"
      pageHeading={
        id != "" && /\d+/.test(id) ? "Edit Storage Item" : "Add Storage Item"
      }
      pageSubTitle={
        id != "" && /\d+/.test(id)
          ? "Edit storage Item information"
          : "Save storage Item information"
      }
    >
      <StorageItemForm storageItemDetail={storageItemDetail} />
    </PageContainer>
  );
};

export default StorageType;
